import { render } from "./subScribeComponent.vue?vue&type=template&id=5289f814&scoped=true"
import script from "./subScribeComponent.vue?vue&type=script&lang=js"
export * from "./subScribeComponent.vue?vue&type=script&lang=js"

import "./subScribeComponent.vue?vue&type=style&index=0&id=5289f814&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5289f814"]])

export default __exports__